export default {
    /** 是否显示右边icon */
    nextIcon: false,
    /** 列表标题文字颜色 */
    color: "",
    /** 列表文本内容文字颜色 */
    textColor: "",
    /** 列表图标颜色 */
    iconColor: "",
    /** 是否显示分割线 */
    splitLine: true,
    /** 背景色 */
    background: "",
    /** 值居左显示 */
    textLeft: false,
    /** 是否在底部增加20px的margin间距 */
    spacing: false,
    /** 是否在底部增加20px的间距（颜色填充方式） */
    spacingFill: false,
    /** 列表文本内容区域是否使用flex布局 */
    textFlex: false,
    /** 固定列表标题宽度 */
    titleFixed: "auto"
}
